(function () {
  'use strict';
  var allowedSources = ['online-education-interest', 'pro-studio-interest'];

  function bindForms() {
    document.querySelectorAll('form[data-hth-coming-soon-source]').forEach(function (form) {
      var source = form.getAttribute('data-hth-coming-soon-source');
      if (allowedSources.indexOf(source) === -1 || form.dataset.hthComingSoonReady) return;
      form.dataset.hthComingSoonReady = 'true';
      var completedKey = '';
      var pending = false;

      form.addEventListener('submit', async function (event) {
        var emailInput = form.querySelector('[name="contact[email]"]');
        var tagsInput = form.querySelector('[name="contact[tags]"]');
        var button = form.querySelector('[type="submit"]');
        var status = form.querySelector('[data-hth-coming-soon-status]');
        if (!emailInput || !tagsInput || !button || !status) return;
        var email = emailInput.value.trim();
        var tags = tagsInput.value.split(',').map(function (tag) { return tag.trim(); });
        if (tags.indexOf(source) === -1) return;
        var key = email.toLowerCase() + '|' + tagsInput.value;
        // The second submit uses Shopify's unchanged form and CAPTCHA handling.
        if (completedKey === key) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pending || !form.reportValidity()) return;

        pending = true;
        var label = button.textContent;
        button.disabled = true;
        button.textContent = 'Saving your interest';
        status.hidden = true;
        var properties = {};
        // Separate booleans preserve both interests if the same person uses both forms.
        properties[source] = true;
        if (source === 'pro-studio-interest') {
          tags.filter(function (tag) { return tag !== 'newsletter' && tag !== source; })
            .forEach(function (tag) { properties['pro-studio-tool-' + tag] = true; });
        }
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 15000);
        try {
          var response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VZLj2d', {
            method: 'POST',
            headers: { accept: 'application/vnd.api+json', revision: '2025-04-15', 'content-type': 'application/vnd.api+json' },
            signal: controller.signal,
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: properties } } } },
              relationships: { list: { data: { type: 'list', id: 'UgqNJw' } } }
            } })
          });
          if (!response.ok) throw new Error('subscription_failed');
          completedKey = key;
          button.disabled = false;
          button.textContent = label;
          // Do not replace Shopify capture, tags, validation, or anti-spam behavior.
          form.requestSubmit(button);
        } catch (error) {
          status.textContent = 'We could not save your signup right now. Please check your connection and try again.';
          status.hidden = false;
        } finally {
          clearTimeout(timeout);
          pending = false;
          button.disabled = false;
          button.textContent = label;
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindForms);
  else bindForms();
  document.addEventListener('shopify:section:load', bindForms);
})();
